import { render } from "./SingleValueChart.vue?vue&type=template&id=0885b9e4"
import script from "./SingleValueChart.vue?vue&type=script&lang=js"
export * from "./SingleValueChart.vue?vue&type=script&lang=js"

import "./SingleValueChart.vue?vue&type=style&index=0&id=0885b9e4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__